import { ButtonBase, styled, svgIconClasses } from "@mui/material";
import { toolbarButtonClasses, toolbarButtonName } from "../classes.js";
const hoverBulge = `&.${toolbarButtonClasses.hoverBulge}`;
const labelOn = `&.${toolbarButtonClasses.labelOn}`;
const selected = `&.${toolbarButtonClasses.selected}`;
const icon = `.${toolbarButtonClasses.icon}`;
const svgIcon = `.${svgIconClasses.root}`;
const excludedProps = ["as", "cssVariables", "icon", "ownerState", "selectedIcon", "sx", "theme"];
const Root = styled(ButtonBase, {
  name: toolbarButtonName,
  overridesResolver: (_props, styles) => [styles.root],
  shouldForwardProp: (prop) => !excludedProps.includes(prop),
  slot: "Root"
})(({ theme, cssVariables: vars }) => ({
  alignItems: "center",
  alignSelf: "center",
  backgroundColor: vars.buttonBackgroundColor,
  borderColor: vars.buttonBorderColor,
  borderRadius: vars.buttonBorderRadius,
  borderStyle: vars.buttonBorderStyle,
  borderWidth: vars.buttonBorderWidth,
  color: vars.buttonColor,
  cursor: vars.buttonCursor,
  display: "flex",
  flexDirection: "column",
  fontFamily: vars.buttonFontFamilyLabelOff,
  fontSize: vars.buttonFontSizeLabelOff,
  gap: theme.spacing(0.75),
  height: theme.spacing(7),
  marginBottom: 0,
  marginLeft: vars.buttonMarginLeft,
  marginRight: vars.buttonMarginRight,
  marginTop: 0,
  userSelect: "none",
  width: theme.spacing(6),
  "&:focus": {
    outline: "none"
  },
  "&:disabled": {
    backgroundColor: vars.buttonBackgroundColorDisabled,
    borderColor: vars.buttonBorderColorDisabled,
    color: vars.buttonColorDisabled,
    cursor: vars.buttonCursorDisabled,
    pointerEvents: "none"
  },
  [labelOn]: {
    width: theme.spacing(7),
    fontFamily: vars.buttonFontFamilyLabelOn,
    fontSize: vars.buttonFontSizeLabelOn
  },
  [`${selected} ${icon}`]: {
    backgroundColor: vars.buttonBackgroundColorSelected,
    color: vars.buttonColorSelected
  },
  [`&:focus ${icon}`]: {
    backgroundColor: vars.buttonBackgroundColorFocus,
    color: vars.buttonColorFocus
  },
  [`&:hover ${icon}`]: {
    backgroundColor: vars.buttonBackgroundColorHover,
    color: vars.buttonColorHover
  },
  [`${labelOn} ${icon}`]: {
    borderRadius: "100px",
    height: theme.spacing(4)
  },
  [`${hoverBulge} ${svgIcon}`]: {
    transition: "transform 0.2s cubic-bezier(0.17, 0.67, 0.55, 1.09)"
  },
  [`${hoverBulge}:hover ${svgIcon}`]: {
    transform: "scale(1.15)"
  }
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
